"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.73 3H6.271C5.343 3 5 3.38 5 4.409V16.83c0 .117.004.225.013.325.021.225.025.443.214.69.018.024.21.184.21.184.105.056.175.097.292.15l5.642 2.618c.293.15.415.207.628.203H12c.213.004.336-.054.629-.203l5.642-2.619c.117-.052.188-.093.291-.15 0 0 .193-.159.211-.183.189-.247.193-.465.214-.69.009-.1.013-.209.013-.325V4.41C19 3.38 18.658 3 17.73 3z" }), "Logo");
//# sourceMappingURL=Logo.js.map